import { render, staticRenderFns } from "./PluginlessWrapper.vue?vue&type=template&id=d32b11ac&scoped=true&"
import script from "./PluginlessWrapper.vue?vue&type=script&lang=js&"
export * from "./PluginlessWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PluginlessWrapper.vue?vue&type=style&index=0&id=d32b11ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32b11ac",
  null
  
)

export default component.exports